const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:8080/api';

let cachedCountries = null;
let fetchPromise = null;

async function fetchCountries() {
    if (cachedCountries) return cachedCountries;
    if (fetchPromise) return fetchPromise;

    // Backend (geography proxy) vraća već mapiran oblik {name, nameEnglish, code, dialCode}
    fetchPromise = fetch(`${API_BASE_URL}/geography/countries`)
        .then((res) => res.json())
        .then((data) => {
            cachedCountries = (Array.isArray(data) ? data : [])
                .filter((c) => c.name)
                .sort((a, b) => a.name.localeCompare(b.name, 'sr'));
            fetchPromise = null;
            return cachedCountries;
        })
        .catch((err) => {
            console.error('CountryService: greška pri dohvatu država:', err);
            fetchPromise = null;
            return [];
        });

    return fetchPromise;
}

const citiesCache = {};

async function fetchCities(countryNameEnglish) {
    if (!countryNameEnglish) return [];
    if (citiesCache[countryNameEnglish]) return citiesCache[countryNameEnglish];

    try {
        const res = await fetch(`https://countriesnow.space/api/v0.1/countries/cities/q?country=${encodeURIComponent(countryNameEnglish)}`);
        const json = await res.json();
        if (!json.error && Array.isArray(json.data)) {
            const blacklist = ['Niksic'];
            const cities = json.data.filter((city) => !blacklist.includes(city)).sort((a, b) => a.localeCompare(b, 'sr'));
            citiesCache[countryNameEnglish] = cities;
            return cities;
        }
    } catch (err) {
        console.error('CountryService: greška pri dohvatu gradova:', err);
    }
    return [];
}

export const CountryService = {
    getCountries: fetchCountries,
    getCities: fetchCities
};
